import preloader from './preloader'
import otherModule from './otherModule'

export default {
  preloader,
  otherModule
}
